import { Button, Modal } from "antd";
import { useCallback } from "react";
import { useIntl } from "react-intl";
import type { RosterTableRow } from "~pages/Roster/components/RosterTable/types/rosterTableRow";

type Props = {
  onDelete: (id: string) => void;
  record: RosterTableRow;
};

const DeleteRosterAction = ({ onDelete, record }: Props) => {
  const { formatMessage } = useIntl();
  const [modal, contextHolder] = Modal.useModal();

  const handleClick = useCallback(() => {
    modal.confirm({
      title: formatMessage({ id: "roster.delete" }),
      content: formatMessage({ id: "roster.delete.confirm" }),
      okText: formatMessage({ id: "delete" }),
      okButtonProps: { loading: false },
      onOk: () => onDelete(record.personId),
    });
  }, [onDelete, formatMessage, modal.confirm, record.personId]);

  return (
    <>
      <Button onClick={handleClick} type={"text"} size={"small"} icon={<i className="fas fa-trash-can mr-2" />} />
      {contextHolder}
    </>
  );
};
export default DeleteRosterAction;
